import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cartorios-extrajudiciais-interior-informacao',
  templateUrl: './cartorios-extrajudiciais-interior-informacao.component.html',
  styleUrls: ['./cartorios-extrajudiciais-interior-informacao.component.css']
})
export class CartoriosExtrajudiciaisInteriorInformacaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
